export function getModuleName(fullName: string): string {
    const indexOfLastSlash = fullName.lastIndexOf('/');
    if (indexOfLastSlash == -1) {
        return fullName;
    }

    return fullName.substring(0, indexOfLastSlash);
}